import styles from '../../UserHistory.module.less';

const HistoryItem = ({ item, month }) => {
  const month_class = month ? styles.month : styles.space;

  return (
    <li>
      <span className={month_class}>{month}</span>
      <a href={item.url}>
        <span>{item.nome}</span>
      </a>
    </li>
  );
};

export default HistoryItem;
